import { useEffect, useMemo, useRef, useState } from "react";
import { cn } from "../../../../../../../utils/cn";
import GetHeroIcon from "../../../../../../../utils/getHeroIcons";

interface ObjectiveMcqQuestionProps {
  options: Record<string, string>;
  updateAnswerKeyHandler: (answerKey: [] | string[]) => void;
  answerKey: string[] | undefined;
}
const ObjectiveScqQuestion = ({
  options,
  updateAnswerKeyHandler,
  answerKey
}: ObjectiveMcqQuestionProps) => {
  const selectedChoices = answerKey || [];
  const optionRefs = useRef<Record<string, HTMLSpanElement | null>>({});
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    const widths = Object.values(optionRefs.current).map(
      (el) => el?.offsetWidth || 0
    );
    const max = Math.max(...widths);
    setMaxWidth(max);
  }, [optionRefs]);

  return (
    <div className="space-y-3 md:space-y-5">
      {Object.entries(options).map((option, index) => {
        const selected = selectedChoices.find((el) => el === option[0]);

        // changing value display to string
        const stringOption = option[1].toString();

        // making first letter capital
        const capitalizedOption =
          stringOption.charAt(0).toUpperCase() + stringOption.slice(1);

        return (
          <div
            onClick={() => {
              const newAnswerKey = [option[0]];
              updateAnswerKeyHandler(newAnswerKey);
            }}
            key={index}
            className={cn(
              "w-full rounded-md p-3 space-x-3 md:space-x-4 border border-border flex items-center cursor-pointer transition-colors hover:border-primary/50",
              selected &&
                "bg-primary-light text-primary border-primary dark:bg-zinc-700 dark:border-none"
            )}
            style={{
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none"
            }}
          >
            <div
              className={cn(
                "w-5 h-5 md:w-6 md:h-6 min-w-5 md:min-w-6 min-h-5 md:min-h-6 flex-shrink-0 rounded-full border border-border flex justify-center items-center cursor-pointer",
                selected && "bg-primary"
              )}
            >
              {selected && (
                <GetHeroIcon name="CheckIcon" className="w-4 h-4 text-white" />
              )}
            </div>
            <span
              ref={(el) => {
                optionRefs.current[option[0]] = el;
              }}
              className="text-sm font-normal text-secondary/90 rounded-xl break-words"
              dangerouslySetInnerHTML={{ __html: `${capitalizedOption}` }}
              style={{ whiteSpace: "pre-line" }}
            ></span>
          </div>
        );
      })}
    </div>
  );
};

export default ObjectiveScqQuestion;
